import React from 'react';
import moment from 'moment';
import { Input } from 'antd';

const CustomDatetimeWidget = props => {
  return (
    <Input
      type={props.schema.format}
      id={props.id}
      name={props.name}
      label={props.label}
      required={props.required}
      disabled={props.disabled || props.readonly}
      value={props.value}
      onChange={props.onChange}
      min={`${moment.unix(props.schema.minimum).format('YYYY-MM-DD')}`}
      max={`${moment.unix(props.schema.maximum).format('YYYY-MM-DD')}`}
      {...props}
    />
  );
};

export default CustomDatetimeWidget;
